import { css } from 'styled-system/css';

export const appbarStyles = {
	root: css({
		base: {
			position: 'fixed',
			alignItems: 'center',
			justifyContent: 'space-around',
			zIndex: 'var(--appbar-zindex)',
			top: 'auto',
			left: 0,
			right: 0,
			bottom: 0,
			height: 'calc(var(--appbar-height) + env(safe-area-inset-bottom))',
			display: 'none',
			color: 'appbar.color',
			textAlign: 'center',
			backgroundColor: 'appbar.bg',
			borderTop: '1px solid',
			borderColor: 'appbar.borderColor',
			px: '6px',
			gap: '6px',
			boxShadow: '0px 10px 10px 0px rgba(0, 0, 0, 0.19)',
			paddingBottom: 'calc(env(safe-area-inset-bottom) + 6px)',
			// paddingBottom: 'calc(env(safe-area-inset-bottom) + 20px)',
			_mars: {
				_mdBelow: {
					display: 'flex',
				},
			},
		},
	}),
	appbarHoist: css({
		base: {
			zIndex: '30!',
		}
	}),
	item: css({
		base: {
			position: 'relative',
			flex: 1,
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
			cursor: 'pointer',
			'&[data-selected=true]': {
				color: 'appbar.selected',
				'& svg': {
					maskImage: 'none',
				}
			},
			'& svg': {
				maskImage: 'linear-gradient(180deg,  rgb(0 0 0 / 12%), #000000a3)',
			},
			_dark: {
				'&[data-selected=true]': {
					'& svg': {
						maskImage: 'none',
					}
				},
				'& svg': {
					maskImage: 'linear-gradient(0deg,  rgba(0, 0, 0, 0), black)',
				},
			},
		},
	}),
	itemText: css({
		base: {
			display: '-webkit-box',
			boxOrient: 'vertical',
			WebkitLineClamp: 1,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			fontSize: '10px',
			fontWeight: '400',
			lineHeight: '12px',
		}
	}),
	badge: css({
		base: {
			position: 'absolute',
			top: '-1.5',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			marginLeft: '20px',
			padding: '0 2px',
			minWidth: '15px',
			height: '15px',
			lineHeight: '1em',
			fontSize: '12px',
			color: 'white',
			backgroundColor: 'red',
			borderRadius: '6px',
		}
	}),
	highlight: css({
		base: {
			position: 'absolute',
			top: '0',
			width: '20%',
			height: 'auto',
			_ltr: {
				right: '0',
			},
			_rtl: {
				left: '0',
			}
		}
	}),
	circle: css({
		base: {
			position: 'absolute',
			top: '-15px',
			width: '60px',
			height: '60px',
			borderRadius: '50%',
			border: '6px solid rgba(235, 154, 59, 0.10)',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			_ltr: {
				right: 'calc(50% - 30px)',
			},
			_rtl: {
				left: 'calc(50% - 30px)',
			},
			'&::before, &::after': {
				content: '""',
				position: 'absolute',
				inset: '-6px',
				borderRadius: '50%',
				border: '6px solid rgba(235, 154, 59, 0.3)',
				animation: 'ripple-out 1.6s infinite cubic-bezier(0.4, 0, 0.2, 1)'
			},
			'&::after': {
				animationDelay: '0.8s'
			}
		}
	}),
	innerCircle: css({
		base: {
			width: '48px',
			height: '48px',
			borderRadius: '50%',
			border: '6px solid rgba(235, 154, 59, 0.50)',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center'
		}
	}),
	coreCircle: css({
		base: {
			width: '36px',
			height: '36px',
			borderRadius: '50%',
			border: '3px solid #EB9A3B'
		}
	}),
	tip: css({
		_mars: {
			display: 'block',
			position: 'absolute',
			color: 'blackOpacity.87',
			bgColor: '#FFF5C2',
			top: '-34px',
			left: '34%',

			_before: {
				bottom: '-4px',
				top: 'unset',
			}
		}
	}),
	badgePoint: css({
		base: {
			top: '0',
			left: '50%',
			width: '6px',
			height: '6px',
			marginLeft: '7px',
		}
	})
}